<template>
  <v-container grid-list-md pt-0 pb-0>
    <!-- <div style="margin-top:17rem !important" v-if="isLoading">
      <v-layout row wrap flex justify-center align-center fill-height>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
    </div> -->

    <!-- <div class=""> -->
    <!-- <v-layout row wrap align-center justify-center>
        <v-flex md12 xs12 sm12> -->
    <!-- <div style="height: calc(100vh - 120px); width: 100%" class="ma-2"> -->
    <l-map
      v-if="showMap"
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      style="height: calc(100vh - 251px);z-index:0"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
    >
      <l-tile-layer :url="url" :attribution="attribution" />
      <div v-for="(i, index) in listAddress" :key="index">
        <l-marker
          :lat-lng="setFormat(i.latitude, i.longitude)"
          v-if="i.lat !== null"
        >
          <l-icon
            :icon-url="setIcon(i.status)"
            :icon-size="dynamicSize"
            :icon-anchor="dynamicAnchor"
            :popup-anchor="popupAnchor"
          />
          <l-popup>
            <span class="font-weight-bold popup-map-header">{{ i.name }}</span>
            <br />
            <span class="popup-map-detail">
              <strong>ที่ตั้ง: </strong>{{ i.address }}
            </span>
            <br />
            <span class="popup-map-detail">
              <strong>โทรศัพท์: </strong> {{ i.phone }}
            </span>
            <br />
            <span class="popup-map-detail">
              <strong>หัวหน้าหน่วยงาน: </strong>
              {{ i.head }}
            </span>
            <br />
            <!-- <span class="fs-16">
              <strong>ตำแหน่ง: </strong> {{ i.ตำแหน่ง }} 
              </span
            ><br /> -->
            <a
              :href="
                'https://www.google.com/maps/search/?api=1&query=' +
                  i.latitude +
                  ',' +
                  i.longitude
              "
              target="_blank"
              ><span class="popup-map-detail">เปิดด้วย Google Map</span></a
            >
            <div @click="innerClick"></div>
          </l-popup>
        </l-marker>
      </div>
    </l-map>
    <!-- </div> -->
    <!-- </v-flex>
      </v-layout> -->
    <!-- </div> -->
  </v-container>
</template>

<script>
import { LMap, LTileLayer, LMarker, LPopup, LIcon } from "vue2-leaflet";
// import { icon } from "leaflet";
// import address from "../assets/json/address2.json";
export default {
  name: "Example",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
  },
  data() {
    return {
      zoom: 6,
      center: [13.736717, 100.523186],
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: [13.736717, 100.523186],
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
      },
      showMap: true,
      listAddress: [],
      iconSize: 35,
      popupAnchor: [0, -20],
    };
  },
  computed: {
    dynamicSize() {
      return [this.iconSize, this.iconSize * 1.15];
    },
    dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize * 1.15];
    },
  },
  created() {
    this.$emit("activeMenu", "howto");
    this.queryAddressNursery();
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    innerClick() {
      alert("Click!");
    },
    queryAddressNursery() {
      // console.log(address);
      // this.listAddress = address;
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryAddressNursery")
        .then((response) => {
          // console.log(response.data);
          this.listAddress = response.data;
          // this.isLoading = false;
        });
    },
    setFormat(lat, lng) {
      if (lat !== null && lng !== null) {
        return [lat, lng];
      }
    },
    setIcon(status) {
      if (status === "ศูนย์เพาะชำกล้าไม้") {
        return require("../assets/pin2.svg");
      } else {
        return require("../assets/pin.svg");
      }
    },
  },
};
</script>

<style scoped>
.lineheight {
  line-height: 0.65 !important;
}
.lineheight30 {
  line-height: 40px !important;
}

.popup-map-header {
  font-family: "IBM Plex Sans Thai", sans-serif;
  font-size: 16px;
}

.popup-map-detail {
  font-family: "IBM Plex Sans Thai", sans-serif;
  font-size: 14px;
}
</style>
